 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-0f63518f":"208176f3","chunk-142f9e38":"53869534","chunk-146bef92":"83986667","chunk-1beecf42":"ed1e68af","chunk-1bf3e0f7":"f115aea4","chunk-1cce5a12":"29b5fd00","chunk-1d5e79d8":"425ff483","chunk-1d9d992f":"698d9cfd","chunk-2194df18":"40712567","chunk-229fca7a":"ad809510","chunk-268f7c93":"c8652cb5","chunk-2760136a":"a725de9b","chunk-2d20fe32":"b8256ba3","chunk-67210631":"713709bd","chunk-755c8cf5":"c8f89335","chunk-76070130":"0309ab5a","chunk-2e40c0d7":"2ce9f844","chunk-3582a72c":"eecfa73c","chunk-358a200c":"b109e6c2","chunk-385631d6":"3c260e92","chunk-3d0984e8":"6bf36780","chunk-44a9101c":"1af09b60","chunk-530e9d1b":"4131d330","chunk-5cdf546e":"afdb2fff","chunk-5e62439f":"c0f7ca2b","chunk-65cdfda8":"ba3006ed","chunk-6641809f":"43ce4c01","chunk-6ee4c71e":"eae6f2e1","chunk-763e234c":"f2d83a0e","chunk-8007790c":"c9627e35","chunk-8389a166":"a3c5052e","chunk-ad390e42":"06a2dced","chunk-bd098f48":"baed0b7f","chunk-c78d230a":"966b121c","chunk-d29b8efe":"2e01e778","chunk-d2d3db38":"8b3eb507","chunk-d54aadf4":"66110e48","chunk-e64ef878":"cb3ffdc8","chunk-e8d6a920":"541b3c35","chunk-f4a7998c":"4e01b71b","chunk-ff3d678e":"7a835baf"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0f63518f":1,"chunk-142f9e38":1,"chunk-146bef92":1,"chunk-1beecf42":1,"chunk-1bf3e0f7":1,"chunk-1cce5a12":1,"chunk-1d5e79d8":1,"chunk-1d9d992f":1,"chunk-2194df18":1,"chunk-229fca7a":1,"chunk-268f7c93":1,"chunk-2760136a":1,"chunk-67210631":1,"chunk-755c8cf5":1,"chunk-76070130":1,"chunk-2e40c0d7":1,"chunk-3582a72c":1,"chunk-358a200c":1,"chunk-385631d6":1,"chunk-3d0984e8":1,"chunk-44a9101c":1,"chunk-530e9d1b":1,"chunk-5cdf546e":1,"chunk-5e62439f":1,"chunk-65cdfda8":1,"chunk-6641809f":1,"chunk-6ee4c71e":1,"chunk-763e234c":1,"chunk-8007790c":1,"chunk-8389a166":1,"chunk-ad390e42":1,"chunk-bd098f48":1,"chunk-c78d230a":1,"chunk-d29b8efe":1,"chunk-d2d3db38":1,"chunk-d54aadf4":1,"chunk-e64ef878":1,"chunk-e8d6a920":1,"chunk-f4a7998c":1,"chunk-ff3d678e":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-0f63518f":"30fd7c04","chunk-142f9e38":"b3e56aa2","chunk-146bef92":"fa9b59a9","chunk-1beecf42":"1c35ed29","chunk-1bf3e0f7":"d0205b2c","chunk-1cce5a12":"697677d3","chunk-1d5e79d8":"8bb4493c","chunk-1d9d992f":"e4e8a14f","chunk-2194df18":"2e58e921","chunk-229fca7a":"bb553d1b","chunk-268f7c93":"6afec155","chunk-2760136a":"cbd228b9","chunk-2d20fe32":"31d6cfe0","chunk-67210631":"55d3bbbc","chunk-755c8cf5":"68a3caa2","chunk-76070130":"012db67e","chunk-2e40c0d7":"0fdd67ad","chunk-3582a72c":"e6253868","chunk-358a200c":"359d2e99","chunk-385631d6":"fba108f9","chunk-3d0984e8":"52a82826","chunk-44a9101c":"b9131c1e","chunk-530e9d1b":"813d2c64","chunk-5cdf546e":"c00495b6","chunk-5e62439f":"2e564d3e","chunk-65cdfda8":"f341ce77","chunk-6641809f":"de8473f5","chunk-6ee4c71e":"65306ac4","chunk-763e234c":"28303caa","chunk-8007790c":"c3b0f1a7","chunk-8389a166":"94f02552","chunk-ad390e42":"89f2e3cb","chunk-bd098f48":"954384d8","chunk-c78d230a":"d2f2a146","chunk-d29b8efe":"efd62ecd","chunk-d2d3db38":"cd60e17d","chunk-d54aadf4":"5ac9321c","chunk-e64ef878":"a491e2e0","chunk-e8d6a920":"6e865e97","chunk-f4a7998c":"9c12abcf","chunk-ff3d678e":"b0ffee62"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/clue/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
